// (c) Copyright 2022 Sorriso Technologies, Inc(r), All Rights Reserved,
// Patents Pending.
//
// This product is distributed under license from Sorriso Technologies, Inc.
// Use without a proper license is strictly prohibited.  To license this
// software, you may contact Sorriso Technologies at:

// Sorriso Technologies, Inc.
// 400 West Cummings Park
// Suite 1725-184
// Woburn, MA 01801, USA
// +1.978.635.3900

// "Sorriso Technologies", "You and Your Customers Together, Online", "Persona
// Solution Suite by Sorriso", the Sorriso Logo and Persona Solution Suite Logo
// are all Registered Trademarks of Sorriso Technologies, Inc.  "Information Is
// The New Online Currency", "e-TransPromo", "Persona Enterprise Edition",
// "Persona SaaS", "Persona Services", "SPN - Synergy Partner Network",
// "Sorriso Synergy", "Our DNA Is In Online", "Persona E-Bill & E-Pay",
// "Persona E-Service", "Persona Customer Intelligence", "Persona Active
// Marketing", and "Persona Powered By Sorriso" are trademarks of Sorriso
// Technologies, Inc.
import $ from 'jquery';

import { ElementState  } from './element_state';
import { ValidatorBase } from './validator_base';

export class ValidatorDateBefore extends ValidatorBase {

    //*************************************************************************
    private when   : Date|undefined;

    //*************************************************************************
    constructor(
                state : ElementState,
                field : JQuery<any>
            ) {
        super(state, field);

        const when = this.field.attr('st-date-before');

        if (when === 'today') {
            this.when = new Date();
            this.when.setHours(0);
            this.when.setMinutes(0);
            this.when.setSeconds(0);
            this.when.setMilliseconds(0);
        } else if (when === 'tomorrow') {
            this.when = new Date();
            this.when.setDate(this.when.getDate() + 1);
            this.when.setHours(0);
            this.when.setMinutes(0);
            this.when.setSeconds(0);
            this.when.setMilliseconds(0);
        } else if (when !== undefined) {
            this.when = $.datepicker.parseDate('%y-%m-%d', when);
        }
        this.set_message('date-before');
    }

    //*************************************************************************
    protected validate() : boolean|undefined {
        const format = this.field.attr('st-date-format');
        const value  = this.as_string();

        if (value !== '' && format !== undefined && this.when !== undefined) {

            try {
                let date = $.datepicker.parseDate(format, value);

                return date < this.when;
            } catch(e) {
                // Invalid date, not our problem.
            }
        }

        return true;
    }
}